import React from 'react';
import styled from 'styled-components';

import Box from 'components/Box';
import { getImageSrc } from 'utils/getImageSrc';
import { hiDPI } from 'utils/style';

export const ImageContainer = styled(
  ({ handle, format, fixedWidth, fullWidth, overlapping, ...props }) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...props} />
  )
)`
  width: 100%;
  height: 100%;
  background-position: center;
  ${(props) => `
    background-size: ${props.fixedWidth ? 'contain' : 'cover'};
    background-image: url('${getImageSrc({
      handle: props.handle,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      width: props.fullWidth ? 996 : props.overlapping ? 696 : 552,
      format: props.format,
      mimetype: props.mimetype,
    })}');
    ${hiDPI()} {
      background-image: url('${getImageSrc({
        handle: props.handle,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-nested-ternary
        width: props.fullWidth ? 1992 : props.overlapping ? 1392 : 1104,
        format: props.format,
        mimetype: props.mimetype,
      })}');
    }
    ${
      !props.fixedWidth
        ? `
      * {
        width: 100%;
        height: 100%;
      }
      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
      }
      img {
        width: 100%;
        height: auto;
        display: none;
      }
      @supports (object-fit: cover) {
        background-image: none;
        img {
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }
      }
    `
        : `
      img {
        width: 100%;
      }
      @supports (object-fit: contain) {
        background-image: none;
        img {
          height: 100%;
          object-fit: contain;
          object-position: center;
          display: block;
        }
      }
        `
    }
  `}
`;
